// extracted by mini-css-extract-plugin
module.exports = {"Description":"ForgotPasswordDialog_Description__2BaCA","ButtonContainer":"ForgotPasswordDialog_ButtonContainer__1n9LA"};